///
/// EarthBrowser
///
/// Created by Matt Giger on 1/11/2025
/// Copyright (c) 2025 Geodata Labs
///

import { DateField } from "@/components/dialogs/subscription/DateField"
import { Button } from "@/components/ui/button"
import { setSubscribeOpen } from "@/redux/dialogSlice"
import { useAppDispatch } from "@/redux/store"
import { PricingPlans } from "@shared-types/pricing-plans"
import type { Subscription } from "@shared-types/subscription"
import { Gift } from "lucide-react"

// Card for the no-cost tiers (`ad_supported` is the legacy identifier for the
// free tier - there is no ad-supported product; see SUBSCRIPTION_PRICING_MODEL.md)
export function SubscriptionCardAdSupported({ subscription }: { subscription: Subscription }) {
	const dispatch = useAppDispatch()
	const planName = PricingPlans[subscription.subscription_id]?.name ?? "Free"

	return (
		<div className="rounded-lg border border-border bg-background p-3 transition-colors hover:bg-muted/50">
			<div className="flex flex-col gap-2">
				<div className="flex items-center gap-3">
					<div className="p-2 rounded-lg bg-muted">
						<Gift className="h-4 w-4 text-muted-foreground" />
					</div>
					<div className="flex items-center gap-2 flex-wrap flex-1 min-w-0">
						<p className="text-sm font-semibold">{planName}</p>
						<span className="px-2 py-0.5 rounded-full bg-muted text-muted-foreground text-xs font-medium">
							Active
						</span>
					</div>
				</div>
				<div className="flex items-center justify-between gap-2">
					<div className="flex items-center text-xs text-muted-foreground">
						<span>Created</span>
						<DateField value={subscription.created_at} />
					</div>
					<Button
						onClick={() => dispatch(setSubscribeOpen(true))}
						size="sm"
						variant="outline"
						className="shrink-0"
					>
						Upgrade
					</Button>
				</div>
			</div>
		</div>
	)
}